import { Editor_Words } from "@/utils/lang/editor";
import { checkAIMeta, getPreviewSrc } from "@/utils/misc";
import { IResponse, langStore, translate, useSelecting } from "@noli/business";
import { shallowCopy } from "@noli/core";
import { ReactNode, useEffect, useMemo, useState } from "react";

interface UseImageWithPlaceholderProps {
  type?: IResponse["type"] | IResponse["type"][];
  src?: string;
  condition?: (type?: IResponse["type"], displayNode?: IResponse["displayNode"]) => boolean; // 如果判断条件很复杂，不能用一个 type 来指代
  placeholderConfig?: {
    noneSelect?: Editor_Words;
    notTargetType?: Editor_Words;
    notTargetTypeNode?: ReactNode;
    notMatchCondition?: Editor_Words;
    notMatchConditionNode?: ReactNode;
  };
}
export const checkNoliboxAICondition =
  () => (type?: IResponse["type"], displayNode?: IResponse["displayNode"]) => {
    return displayNode?.type === "image" ? checkAIMeta(shallowCopy(displayNode.meta)) : true;
  };
export const checkNoliboxAndMonkeyCondition =
  () => (type?: IResponse["type"], displayNode?: IResponse["displayNode"]) => {
    return displayNode?.type === "image"
      ? checkAIMeta(shallowCopy(displayNode.meta)) || displayNode.meta?.type === "monkey"
      : false;
  };

export default function useImageWithPlaceholder(props?: UseImageWithPlaceholderProps) {
  const { src, placeholderConfig, type = "image", condition } = props ?? {};
  const lang = langStore.tgt;
  const { type: selectType, displayNode } = useSelecting("raw");
  const alias = displayNode?.alias ?? "";
  // imageNode 特有
  const meta = displayNode?.type === "image" ? shallowCopy(displayNode?.meta) : undefined;
  // const [uploadUrl, setUploadUrl] = useState("");

  const enableTypes = useMemo(() => {
    if (Array.isArray(type)) return type;
    return [type];
  }, [type]);

  const fullyEnable = useMemo(() => {
    let enable = false;
    if (!enableTypes.includes(selectType)) {
      enable = false;
      return enable;
    }
    if (!condition || (condition && condition(selectType, displayNode))) {
      enable = true;
    } else {
      enable = false;
    }
    return enable;
  }, [enableTypes, condition, selectType, displayNode]);

  const previewSrc = src || (fullyEnable ? getPreviewSrc(alias) : "");

  const placeholder = useMemo(() => {
    if (selectType === "none") {
      return translate(placeholderConfig?.noneSelect || Editor_Words["select-a-picture"], lang);
    }
    if (!enableTypes.includes(selectType)) {
      return (
        placeholderConfig?.notTargetTypeNode ??
        translate(
          placeholderConfig?.notTargetType || Editor_Words["current-select-not-image"],
          lang,
        )
      );
    }
    if (condition && !condition(selectType, displayNode)) {
      return (
        placeholderConfig?.notMatchConditionNode ??
        placeholderConfig?.notTargetTypeNode ??
        translate(
          placeholderConfig?.notMatchCondition ||
            placeholderConfig?.notTargetType ||
            Editor_Words["current-select-not-image"],
          lang,
        )
      );
    }

    return "";
  }, [selectType, meta, lang, enableTypes, displayNode, condition]);

  // useEffect(() => {
  //   if (displayNode && uploadUrl) {
  //     setUploadUrl("");
  //   }
  // }, [displayNode]);
  return {
    url: previewSrc,
    placeholder,
    enable: !!previewSrc || fullyEnable,
    alias: fullyEnable ? alias : "",
    meta: fullyEnable ? meta : null,
    // setUploadUrl,
  };
}
